var _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSurveyReport = function SvgIconSurveyReport(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.404,
    height: 31.51,
    viewBox: "0 0 25.404 31.51",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c,.d{fill:#fff;stroke:#11526a;stroke-linecap:round;stroke-linejoin:round}.a{stroke-width:.963px}.b{stroke-width:1.204px}.c{stroke-width:1.124px}.d{stroke-width:.562px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2037.272 -97.941)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2057.258,128.678H2039.65a1.9,1.9,0,0,1-1.9-1.9V103.165a1.9,1.9,0,0,1,1.9-1.9h13.172l6.331,6.973v18.541A1.9,1.9,0,0,1,2057.258,128.678Z",
    transform: "translate(0 0.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2059.9,125.951H2042.29a1.9,1.9,0,0,1-1.9-1.895V100.438a1.9,1.9,0,0,1,1.9-1.895h13.172l6.331,6.972v18.542A1.9,1.9,0,0,1,2059.9,125.951Z",
    transform: "translate(0.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2060.4,105.446h-6.812V98.554Z",
    transform: "translate(1.69 0.001)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6.631,
    transform: "translate(2044.319 108.458)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 4.838,
    transform: "translate(2053.014 108.458)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.533,
    transform: "translate(2044.319 112.651)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.776,
    transform: "translate(2044.319 116.844)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.776,
    transform: "translate(2044.319 121.703)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 13.066,
    transform: "translate(2045.028 112.947)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSurveyReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-survey-report.3ba5e74c.svg";
export { ForwardRef as ReactComponent };